/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_DescriptionInputs */

const en_sidebar_description = /** @type {(inputs: Sidebar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Displays the mobile sidebar.`)
};

const pt_br2_sidebar_description = /** @type {(inputs: Sidebar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exibe a barra lateral no celular.`)
};

/**
* | output |
* | --- |
* | "Displays the mobile sidebar." |
*
* @param {Sidebar_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const sidebar_description = /** @type {((inputs?: Sidebar_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_description(inputs)
	return pt_br2_sidebar_description(inputs)
});